module.exports = __webpack_public_path__ + "img/logo-wellness.29ab5b78.png";